import { FC } from 'react';
import { Box, Typography, Stack, CircularProgress } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { FormatType } from '../types';

interface FormatTypeSelectorProps {
  formatTypes: FormatType[];
  isGenerating: boolean;
  generatingPromptId: string | null;
  onSelect: (promptId: string) => void;
}

const FormatTypeSelector: FC<FormatTypeSelectorProps> = ({
  formatTypes,
  isGenerating,
  generatingPromptId,
  onSelect,
}) => {
  if (formatTypes.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ px: 0.5 }}>
        Generate a new format
      </Typography>
      {formatTypes.map((type) => {
        const isThisGenerating = isGenerating && generatingPromptId === type.prompt_id;

        return (
          <Box
            key={type.prompt_id}
            onClick={() => !isGenerating && onSelect(type.prompt_id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.5,
              borderRadius: 2,
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              cursor: isGenerating ? 'default' : 'pointer',
              opacity: isGenerating && !isThisGenerating ? 0.5 : 1,
              transition: 'all 0.15s',
              '&:hover': isGenerating
                ? {}
                : {
                    borderColor: 'primary.main',
                    bgcolor: 'action.hover',
                  },
            }}
          >
            {isThisGenerating ? (
              <CircularProgress size={20} />
            ) : (
              <AutoAwesomeIcon sx={{ fontSize: 20, color: 'primary.main' }} />
            )}
            <Typography variant="body2" fontWeight={500}>
              {type.display_name}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default FormatTypeSelector;
